import Footer from "./components/Footer";
import Header from "./components/Header";
import LandingPage from "./components/LandingPage";

function App() {
    return (
        <>
            <Header />
            <Footer />
        </>
    );
}

export default App;
